import React from "react";
import { Modal, Button, Typography } from "antd";

const { Title } = Typography;

export function SpecRow({ spec, index }) {
  return (
    <div key={`${spec.spec_concat}-${index}`} className="notif_spec_row">
      <span className="notif_spec_row_spec">{spec.spec_concat}</span>
      <span className="notif_spec_row_card">Card {spec.card_no}</span>
      {spec.task_description && (
        <span className="notif_spec_row_desc">{spec.task_description}</span>
      )}
    </div>
  );
}

export function AffectedSpecsList({ specs, full }) {
  return (
    <div className={`notif_specs_list ${full ? "notif_specs_list--full" : ""}`}>
      {specs.map((s, idx) => (
        <SpecRow key={`${s.spec_concat}-${idx}`} spec={s} index={idx} />
      ))}
    </div>
  );
}

export function AffectedSpecsModal({ open, onClose, specs }) {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      width={640}
      centered
      title={
        <Title level={5} style={{ margin: 0 }}>
          Affected Specs ({specs.length})
        </Title>
      }
      footer={[
        <Button key="close" onClick={onClose}>
          Close
        </Button>,
      ]}
    >
      <AffectedSpecsList specs={specs} full />
    </Modal>
  );
}
